import { useAuthContext } from "providers/Auth";
import { Links } from "./constants";
import { PropertyManagementSystem } from "shared/types/partner";

export const shouldShowGlobalLink = (
  name: string,
  type: ReturnType<typeof useAuthContext>["type"]
) => {
  if (name === Links.INBOX) return type.isBoomCRM && type.isCommunication;
  if (name === Links.CONTACTS) return type.isBoomCRM;
  if (name === Links.TASKS) return type.isBoomCRM;

  if (
    (type.isPropertyManager || !type.isBoomScreen) &&
    name === Links.PROPERTY_GROUPS
  )
    return false;

  if (
    (!type.isBoomCRM || !type.isBoomScreen || !type.isCrmFeatureWorkflows) &&
    name === Links.WORKFLOWS
  )
    return false;

  return true;
};

export const shouldShowReportingLinks = (
  name: string,
  type: ReturnType<typeof useAuthContext>["type"],
  partner: ReturnType<typeof useAuthContext>["partner"]
) => {
  const isAppfolio =
    partner?.property_management_system?.name ===
    PropertyManagementSystem.Appfolio;

  const isBlockedRenter =
    name === Links.RENTERS &&
    (!type.isPMS || (type.isBoomScreen && !type.isRentReporting) || isAppfolio);

  return !isBlockedRenter;
};
